
import md5 from 'md5'
// 清空对象属性值
export function clearObj(obj) {
    // 清空from对象
    Object.keys(obj).forEach(key => (obj[key] = ''));
}
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}
// 一键复制功能
export function copyToClip(row){
    var input = document.createElement("input"); // 创建input对象
    input.value = row; // 设置复制内容
    document.body.appendChild(input); // 添加临时实例
    input.select(); // 选择实例内容
    document.execCommand("Copy"); // 执行复制
    document.body.removeChild(input); // 删除临时实例
    // this.$message.success('复制成功！');
}

export function sortByKey(array, key) {
    return array.sort(function (a, b) {
      var x = a[key]
      var y = b[key]
      return ((x < y) ? -1 : ((x > y) ? 1 : 0))
    })
  }

  export function getGetUrl(url, method, params) {
    const origin = window.location.origin,
      reg = [RegExp(/localhost/), RegExp(/test/)]
    var ipUrls = localStorage.getItem('ipUrl')
    var ips = ''
    if (reg[0].test(origin) || reg[1].test(origin)) {
      // config.baseURL = process.env.VUE_APP_BASE_TEST_API;
      ipUrls = localStorage.getItem('ipUrl');
      ips = ipUrls ? ipUrls : process.env.VUE_APP_BASE_TEST_API
    } else {
      // config.baseURL = process.env.VUE_APP_BASE_API;
      ipUrls = localStorage.getItem('ipUrl');
      ips = ipUrls ? ipUrls : process.env.VUE_APP_BASE_API
    }
    var baseUrl = `${url}`
    // hash验证
    const time = parseInt(Date.now() / 1000)
    var apptypes = localStorage.getItem("apptypes") || "examWeb";
    // if (config.params && config.params.app_type) {
    //   apptypes = config.params.app_type
    // }
    // if (!apptypes) {
    //   apptypes = 'base'
    // }
    var realParams = Object.assign({}, params, {
      app_type: apptypes,
      timestrap: time,
      platform: 'admin'
    })
    const keys = Object.keys(realParams)
    const keysArray = []
    var getParams = ''
    keys.forEach(item => {
      if (realParams[item] !== undefined) {
        keysArray.push({
          label: item,
          value: realParams[item]
        })
        getParams += `${item}=${realParams[item]}&`
      }
    })
    const sortKeysArray = sortByKey(keysArray, 'label')
    var hashStrs = ''
    sortKeysArray.forEach(item => {
      hashStrs += item.label + item.value
    })
    // const hashKey = '1234567890' // 测试环境

    const hashKey = process.env.NODE_ENV === 'production' ? 'BF2CAEC459F801E99B8F4C5FE93952B3' : '1234567890'

    const hash = md5(hashStrs + hashKey)
    console.log(realParams, keysArray, sortKeysArray, hashStrs + hashKey, hash)

    // realParams.sign = hash

    var url = `${baseUrl}?${getParams}sign=${hash}`
    console.log('getGetUrl', url, getParams)
    return url
  }
